const validateLuhn = (cardNumber: string): boolean => {
  if (!cardNumber || cardNumber === '0') {
    return false;
  }
  return (
    cardNumber
      .split('')
      .reverse()
      .map(digit => parseInt(digit, 10))
      .map((digit, idx) => (idx % 2 ? digit * 2 : digit))
      .map(digit => (digit > 9 ? (digit % 10) + 1 : digit))
      .reduce((accum, digit) => (accum += digit)) %
      10 ===
    0
  );
};
export default validateLuhn;